//
// 下スクロール時のヘッダー非表示処理。
//
exports.scrolledHeader = () =>
{
	window.addEventListener("scroll", onScrolled);
	function onScrolled() {
		const body = document.body;
		const h = window.innerHeight;
		const scr = window.pageYOffset;
		const fire = h - 100;
		if (fire < 0) fire = 1;

		if (scr < fire) {
			body.classList.add("is-noscroll");
		} else {
			body.classList.remove("is-noscroll");
		}
	}
}
//
// ハンバーガーボタンの処理。
//
exports.clickedHamburger = () =>
{
	const e = document.querySelector(".js-hamburger");

	// 要素がない場合は処理しない。
	if (!e) return;

	// ハンバーガーボタンクリック時のイベント。
	e.addEventListener('click', function()
	{
		document.body.classList.toggle('is-hamburger');
	});
}